// extracted by css-extract-rspack-plugin
export default {"root":"HKF7QH","url":"dpDGaJ"};